module.exports = __webpack_public_path__ + "static/media/metrostation-de-pijp.472d2c26.jpg";